import { userProfileConstants } from '../../_constants';
import swal from 'sweetalert2';
// import { history } from '../../_helpers';


const initialState = { createProfileLoading: true, data: '', error: false };

export function createProfileReducer(state = initialState, action) {

    switch (action.type) {
        case userProfileConstants.REQUEST_CREATE_PROFILE:
            return {
                createProfileLoading: true,
                data: '',
                error: false
            };
        case userProfileConstants.RECEIVE_CREATE_PROFILE:
            swal({
                text: 'Successfully profile Created',
                type: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            })
            //   history.push('/login');
            return {
                createProfileLoading: false,
                data: action.createProfile,
                error: false
            };
        case userProfileConstants.CREATE_PROFILE_ERROR:

            return {
                createProfileLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/userProfile/createProfile.reducer.js